import React, { useEffect, useContext, useState } from 'react';
// import { useCookies } from "react-cookie";
import fetchOptionsBuilder from '../fetchOptionBuilder';
import WorkflowContext from '../workflowContext';


function getSessionStorageOrDefault(key, defaultValue) {
    const stored =  sessionStorage.getItem(key);
    if (!stored) {
      return defaultValue;
    }
    return JSON.parse(stored);

  }

export default function Phylotree({ id, style }) {
    const workflow = useContext(WorkflowContext);
    // const [cookies, setCookie, removeCookie] = useCookies(['auth', 'userid']);

    const [apitoken, setApitoken] = useState(             // eslint-disable-line no-unused-vars
        getSessionStorageOrDefault('apitoken', null)
    );

    const getDataUserId = JSON.parse(sessionStorage.getItem('userid'));

    useEffect(() => {
        const abortCont = new AbortController()
        const phylotreeContainer = document.getElementById("phylotree-container")
        phylotreeContainer.innerHTML = ""
        // get cluster data for selected gene
        fetch(process.env.REACT_APP_VISUALIZATION_API_PATH + `clusters/${id}/tree`, fetchOptionsBuilder(apitoken, workflow, getDataUserId))
            .then(response => response.text())
            .then(data => {
                (async function (Phylocanvas) {
                    var tree = await Phylocanvas.createTree('phylotree-container');
                    await tree.load(data);
                    await tree.setNodeSize(25);
                    await tree.setTextSize(25);
                    tree.lineWidth = 3;
                    await tree.draw();
                })(window.Phylocanvas);
            });
        return () => abortCont.abort()
    }, [id]);
    return (
        <div className="phylotree-container" id="phylotree-container" style={style} />
    );
}
